import { render, staticRenderFns } from "./PowerbiTester.vue?vue&type=template&id=5f0bf3d9&"
import script from "./PowerbiTester.vue?vue&type=script&lang=js&"
export * from "./PowerbiTester.vue?vue&type=script&lang=js&"
import style0 from "./PowerbiTester.vue?vue&type=style&index=0&id=5f0bf3d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports